// Document ids on the server are 64-bit and exceed Number.MAX_SAFE_INTEGER,
// so the numeric `avatarDocumentId` from a JSON payload silently loses precision.
// The string `avatarDocumentURL` embeds the real id in `<tenant>/<docId>/<filename>`
// shape and preserves it; pull the id back out as a string.
export function parseAvatarDocumentId(url) {
  if (!url || typeof url !== 'string') return null;
  return url.split('/')
    .filter((segment) => /^\d+$/.test(segment))
    .reduce((longest, segment) => (
      !longest || segment.length > longest.length ? segment : longest
    ), null);
}
